import Billboard, { OuterProps } from './Billboard';
import { Side } from './constants';

export { Side, OuterProps as BillboardProps };
export default Billboard;
